<template>
  <div class="m-dropdown-button" role="group" :aria-label="dropdownAriaText">
    <div ref="button" class="m-dropdown-button__button" @click="toggleButton">
      <slot name="button" />
    </div>
    <div
      v-show="showMenu"
      ref="dropdownMenu"
      class="m-dropdown-button__dropdown-menu"
      :aria-label="dropdownMenuAriaText"
      :aria-expanded="showMenu"
    >
      <slot name="dropdownMenu" v-bind="{ isOpen: showMenu }" />
    </div>
  </div>
</template>

<script>
import { useLocalization } from "@thegetty-private/getty-ui";

export default {
  name: "DropdownButton",
  components: {},

  emits: ["toggleIcon"],
  setup(props) {
    return {
      ...useLocalization({
        baseLocaleKey: props?.baseLocaleKey
      })
    };
  },
  data() {
    return {
      /**
       * Aria label text for the top level dropdown component
       */
      dropdownAriaText: this.translatePart("object_page.dropdown_button_aria"),
      /**
       * Aria label text for the dropdown menu contents
       */
      dropdownMenuAriaText: this.translatePart(
        "object_page.dropdown_menu_aria"
      ),
      /**
       * Whether or not to display the dropdown menu
       */
      showMenu: false
    };
  },
  methods: {
    toggleButton() {
      this.showMenu = !this.showMenu;
      this.$emit("toggleIcon");
    }
  }
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
